import request from '../request'

export function fetchList(params) {
    return request({
        url: '/market-service/bid/item/list',
        params
    })
}


export function fetchDetail(params) {
    return request({
        url: '/market-service/bid/item/query/' + params.id,
    })
}

export function add(data) {
    return request({
        url: '/market-service/bid/item/add',
        method: 'post',
        data
    })
}

export function edit(data) {
    return request({
        url: '/market-service/bid/item/update',
        method: 'post',
        data
    })
}

// 修改后提交(驳回后重新提交)
export function resubmit(data) {
    return request({
        url: '/market-service/bid/item/resubmit',
        method: 'post',
        data
    })
}

// 中标公示修改后提交(驳回后重新提交)
export function winResubmit(data) {
    return request({
        url: '/market-service/bid/item/winResubmit',
        method: 'post',
        data
    })
}

export function cancel(data) {
    return request({
        url: '/market-service/bid/item/cancel/' + data.id,
        method: 'post',
    })
}

// 中标通知发送
export function sendWin(data) {
    return request({
        url: '/market-service/bid/item/win',
        method: 'post',
        data
    })
}

